import { takeLatest, call, put } from "redux-saga/effects";
import { REGIONS_PAGE_LOAD, regionsLoaded } from "../../actions/regions";
import listRegions from "../../../../../backend/oncall/partners/regions/list";
import { showErrorPage } from "../../../../../actions/ui/location";

const regionsPageLoadSaga = function*(action) {
  try {
    const result = yield call(listRegions);
    yield put(regionsLoaded(result.regions));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(REGIONS_PAGE_LOAD, regionsPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/regions/list-page-load.js